import { useState, useEffect, useCallback } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import RotationConfigForm from './components/RotationConfigForm';
import RotationMenu from './components/RotationMenu';
import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';
import Reload from '../../components/reload/reload';
import Api from '../../services/Api';
import '../DashMedidas/DashMedidas.css';
import '../../styles/SguUnitsPage.css';

const getOtherEquipmentsArray = (unit) =>
  Array.isArray(unit?.otherEquipments) ? unit.otherEquipments : [];

const hasRodzEquipment = (unit) =>
  getOtherEquipmentsArray(unit).some(e => e.serialNumber?.toUpperCase().includes('RODZ'));

const getRodzSerials = (unit) =>
  getOtherEquipmentsArray(unit)
    .filter(e => e.serialNumber?.toUpperCase().includes('RODZ'))
    .map(e => e.serialNumber);

const Rotation = () => {
  const [loading, setLoading] = useState(true);

  const allUnits = JSON.parse(localStorage.getItem('units')) ||
    [JSON.parse(localStorage.getItem('cooperative'))] ||
    [];

  const rodzUnits = allUnits.filter(hasRodzEquipment);

  const [user] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [filteredUnits, setFilteredUnits] = useState(rodzUnits);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [rodzDataMap, setRodzDataMap] = useState({});

  useEffect(() => {
    const allSerials = rodzUnits.flatMap(getRodzSerials);

    const fetchRotations = async () => {
      try {
        const { data } = await Api.post('/rotation/v1/filtered', { listSerialNumbers: allSerials });
        const map = {};
        data.forEach(item => { map[item.serialNumber] = item; });
        setRodzDataMap(map);
      } catch (e) {
        console.error('Erro ao buscar rodízios:', e);
      } finally {
        setLoading(false);
        if (rodzUnits.length > 0) setSelectedUnit(rodzUnits[0]);
      }
    };

    if (allSerials.length > 0) {
      fetchRotations();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRodzEquipments = (unit) =>
    getRodzSerials(unit).map(serial =>
      rodzDataMap[serial] ||
      getOtherEquipmentsArray(unit).find(e => e.serialNumber === serial)
    ).filter(Boolean);

  const handleRotationUpdate = (updated) => {
    setRodzDataMap(prev => ({ ...prev, [updated.serialNumber]: updated }));
  };

  const handleSearchData = useCallback((value) => {
    setSearchValue(value);
    const upper = value.toUpperCase();
    const filtered = rodzUnits.filter(item =>
      item?.name?.toUpperCase().includes(upper) ||
      item?.email?.toUpperCase().includes(upper) ||
      item?.cnpj?.toUpperCase().includes(upper)
    );
    setFilteredUnits(filtered);
    setSelectedUnit(filtered.length > 0 ? filtered[0] : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unitsHeaderRight = selectedUnit ? (
    <span className="dash-section-card__header-meta">1 selecionada</span>
  ) : null;

  return (
    <Page title="Rodízio">
      <Headers page="Rodízio" />
      {loading && <Reload />}

      <div className="dash-medidas-page dash-medidas-container sgu-units-page">
        <div className="dash-medidas-stack">
          <Row className="dash-medidas-grid g-3 sgu-units-main-row">
            <Col xs={12} md={4} lg={3} xl={3} className="sgu-units-col">
              <RotationMenu
                user={user}
                units={filteredUnits}
                onUnitSelect={setSelectedUnit}
                onSearch={handleSearchData}
                selectedUnit={selectedUnit}
                searchValue={searchValue}
                headerRight={unitsHeaderRight}
              />
            </Col>

            <Col xs={12} md={8} lg={9} xl={9} className="sgu-units-content-col">
              <div className="dash-medidas-stack sgu-units-content-scroll">
                {selectedUnit ? (
                  <RotationConfigForm
                    user={user}
                    unit={selectedUnit}
                    alarmEquipments={getRodzEquipments(selectedUnit)}
                    onAlarmUpdate={handleRotationUpdate}
                  />
                ) : (
                  <Alert variant="warning" className="text-center mb-0 sgu-empty-alert">
                    Selecione uma unidade para configurar o rodízio
                  </Alert>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Page>
  );
};

export default Rotation;
